import React from "react";
import styled from "styled-components";

const Q = styled.blockquote`
`

const S = styled.small`
  display: inline-block;
  width: 100%;
  text-align: right;
`

export const Quote = ({ source = "", url = "", children }) => {
  return (
    <Q cite={url}>
      <p>{children}</p>
      {
        source && url && <S>出典：{source}（{decodeURI(url)}）</S>
      }
    </Q>
  )
}
